export default __webpack_public_path__ + "static/media/bookworm-green.177d3291.svg";